import React from "react";
import StatusController from "./StatusController";
import ProfilePictureController from "./ProfilePictureController";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSelectedUser } from "../../../../slices/users/userManagementSlice";
import IconHome from "../../../../styles/icons/IconHome";
import { IUser } from "../../../../pages/user-management/models/User";

const UserCard: React.FC<{ user: IUser; id?: number }> = ({ user, id }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const handleSelectedUser = () => {
    dispatch(setSelectedUser(user));
  };

  return (
    <div className="user-card">
      <div className="profile-photo">
        <ProfilePictureController
          firstName={user.firstName}
          lastName={user.lastName}
          image={user.profileImage}
        />
      </div>
      <div className="profile-data">
        <Link
          onClick={handleSelectedUser}
          to={`view-profile/${id ? id : user.id}`}
        >
          <div className="name">
            <span className="first-name">{user.firstName}</span>
            <span className="last-name">{user.lastName}</span>
          </div>
          <div className="department">{user.userName}</div>
          <div className="designation">{user.userRole}</div>
        </Link>
      </div>
      <div className="status">
        <StatusController state={user.state} />
      </div>
      <div className="edit-icon">
        <Link
          to={`${location.pathname}/edit/${id ? id : user.id}`}
          onClick={handleSelectedUser}
        >
          <IconHome breadcrumb={"edit"} activeColor={undefined} />
        </Link>
      </div>
    </div>
  );
};

export default UserCard;
